export default "__VITE_ASSET__BSHd27Kz__"